import { useEffect, useRef, useState } from 'react';

export const useBarcodeScanner = ({ handleCallback }) => {
    const [isScanning, setIsScanning] = useState(false);
    const scannedRef = useRef('');
    const timerRef = useRef(null);

    const startScanning = () => {
        setIsScanning(true);
    };

    const stopScanning = () => {
        setIsScanning(false);
    };

    useEffect(() => {
        const handleKeyPress = async (event) => {
            // Collect characters from barcode scanner
            if (typeof event.key === 'string' && event.key.length === 1) {
                scannedRef.current += event.key;
                // Reset buffer timer on each keypress
                if (timerRef.current) clearTimeout(timerRef.current);
                timerRef.current = setTimeout(() => {
                    scannedRef.current = '';
                }, 300);
            }
            if (isScanning) {
                if (event.key === 'Enter') {
                    const barcodeValue = scannedRef.current.trim();
                    scannedRef.current = '';

                    if (typeof handleCallback === 'function') {
                        handleCallback(barcodeValue);
                    }
                }
            }
        };

        window.addEventListener('keypress', handleKeyPress);
        return () => {
            window.removeEventListener('keypress', handleKeyPress);
            if (timerRef.current) clearTimeout(timerRef.current);
            scannedRef.current = '';
        };
    }, [isScanning, handleCallback]);

    return {
        isScanning,
        startScanning,
        stopScanning,
    };
};
